import { PROYECT } from "services/api";
import { saveAs } from 'file-saver';
import { START_REQUEST_SEARCH } from "redux/reducers/search/searchReducer";
import { STOP_REQUEST_SEARCH } from "redux/reducers/search/searchReducer";
import { SET_SNACKBAR_SEARCH } from "redux/reducers/search/searchReducer";
import { api_get } from "services/api";

export const getReport =  async (year, months, rfc, stations, dispatch) => {
  const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/xml_volumetrics/volumetrics_report?year=${year}&months=${months.join("&months=")}&rfc=${rfc}&stations=${stations.join("&stations=")}`;

  dispatch({type: START_REQUEST_SEARCH});
  try {
    const response = await api_get(reportUrl);
    dispatch({type: STOP_REQUEST_SEARCH});
    return {
      ...response,
      gn3Registers: response?.gn3Registers.map(row => {
        if(row?.permission.includes('/EXP/')) return {
          ...row,
          ltEntries: row.ltExits,
          kgEntries: row.kgExits,
          totalEntries: row.totalExits,
          initialExistence: 1000
        }
        else return row
      })
    }
  } catch (err) {
    dispatch({
      type: SET_SNACKBAR_SEARCH,
      payload: { message: err.message?.error ? err.message.error : err, color: 'danger' }
    });
    dispatch({type: STOP_REQUEST_SEARCH});
    return false
  }
};

export const downloadReport =  (year, months, rfc, stations, token) => {
  const auth = { headers: { authorization: token } };
  const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/xml_volumetrics?year=${year}&months=${months.join("&months=")}&RFCContribuyente=${rfc}&stations=${stations.join("&stations=")}`;
  const fileName = `Reporte_${year}_${months.join(",")}_${stations.join(",")}.zip`;

  return async (dispatch) => {
    dispatch({type: START_REQUEST_SEARCH});
    const startTime = performance.now();
    try {
      const response = await fetch(reportUrl, auth);
      const blob = await response.blob();
      
      const endTime = performance.now();
      const requestTime = (endTime - startTime)/1000;
      console.log(`Tiempo de espera ${requestTime} segundos`);

      if(response.status !== 200) throw JSON.parse(await blob.text())?.message?.error;
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'XML Descargado con éxito', color: 'success' }
      });
      saveAs(blob, fileName);
    } catch (err) {
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: err?.message?.error ? err.message.error : 'Error en el servicio', color: 'danger' }
      });
    }

    dispatch({type: STOP_REQUEST_SEARCH});
  };
};
